// noinspection DuplicatedCode

import {createAsyncThunk, createSlice,} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

// API
export const getSpecIzin = createAsyncThunk(
    "claimPengobatanTransaksi/getSpecIzin",
    async ({TransaksiApprovalID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("TransaksiApprovalID", TransaksiApprovalID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getSpecIzin',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)


export const getIzinTransaksi = createAsyncThunk(
    "izinTransaksi/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getIzin',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)


export const getIzinLaporan = createAsyncThunk(
    "getIzinLaporan/post",
    async (obj, thunkAPI) => {

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'hrd/izin/lap',
                obj,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const insertIzinTransaksi = createAsyncThunk(
    "izinTransaksi/insert",
    async ({
               Nik,
               JenisIzin,
               KeperluanIzin,
               Pengganti,
               TanggalMulai,
               TanggalAkhir,
               Tiket,
               JamAwal,
               JamAkhir
           }, thunkAPI) => {
        let formData = new FormData();
        formData.append("Nik", Nik);
        formData.append("JenisIzin", JenisIzin);
        formData.append("KeperluanIzin", KeperluanIzin);
        formData.append("Pengganti", Pengganti);
        formData.append("TanggalMulai", TanggalMulai);
        formData.append("TanggalAkhir", TanggalAkhir);
        formData.append("Tiket", Tiket);
        formData.append("JamAwal", JamAwal);
        formData.append("JamAkhir", JamAkhir);


        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'insertIzin',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const updateIzinTransaksi = createAsyncThunk(
    "izinTransaksi/update",
    async ({
               TIzinID,
               Nik,
               JenisIzin,
               KeperluanIzin,
               Pengganti,
               TanggalMulai,
               TanggalAkhir,
               Tiket,
               JamAwal,
               JamAkhir
           }, thunkAPI) => {
        let formData = new FormData();
        formData.append("TIzinID", TIzinID);
        formData.append("Nik", Nik);
        formData.append("JenisIzin", JenisIzin);
        formData.append("KeperluanIzin", KeperluanIzin);
        formData.append("Pengganti", Pengganti);
        formData.append("TanggalMulai", TanggalMulai);
        formData.append("TanggalAkhir", TanggalAkhir);
        formData.append("Tiket", Tiket);
        formData.append("JamAwal", JamAwal);
        formData.append("JamAkhir", JamAkhir);

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'updateIzin',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)
export const resetIzinSlice = createAsyncThunk(
    "resetIzinSlice/update",
    async ({}, thunkAPI) => {
        return true
    }
)
//INIT
const initialState = {
    message: "",
    SpecIzinData: [],
    isSpecIzinFetching: false,
    isSpecIzinSuccess: false,
    isSpecIzinError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
    report: [],
    reportDetail: null,
    isGetReport: false
};


//SLICES
export const izinTransaksiSlice = createSlice({
    name: "izinTransaksi",
    initialState,
    reducers: {},
    extraReducers: {

        [resetIzinSlice.fulfilled]: (state, {payload}) => {

            state = initialState;
            return state;
        },

        // GET
        [getSpecIzin.fulfilled]: (state, {payload}) => {
            state.SpecIzinData = payload.data[0];
            state.isSpecIzinSuccess = true;
            state.message = payload.message;
            return state;
        },
        [getSpecIzin.rejected]: (state, {payload}) => {
            state.isSpecIzinFetching = false;
        },
        [getSpecIzin.pending]: (state) => {
            state.isSpecIzinFetching = false;
        },

        [getIzinLaporan.fulfilled]: (state, {payload}) => {
            state.report = payload.data;
            state.message = payload.message;
            state.isGetReport = true;
            return state;
        },
        [getIzinLaporan.rejected]: (state, {payload}) => {
            state.isSpecIzinFetching = false;
        },
        [getIzinLaporan.pending]: (state) => {
            state.isSpecIzinFetching = false;
        },


        [getIzinTransaksi.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getIzinTransaksi.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getIzinTransaksi.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertIzinTransaksi.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertIzinTransaksi.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertIzinTransaksi.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateIzinTransaksi.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateIzinTransaksi.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateIzinTransaksi.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});


export const izinTransaksiSelector = (state) => state.izinTransaksi;
